<template>
  <div id="update">
    <div class="row">
      <div class="col-12">
        <h4 class="font-weight-bold">Actualización de usuario</h4>
      </div>
      <div class="col-12 mt-3">
        <form class="row" v-on:submit.prevent="updateUser">
          <div class="col-12 col-lg-6 form-group">
            <label for="name">Nombres</label>
            <input type="text"
              name="name"
              id="name"
              class="form-control"
              placeholder="Ingresa tus nombres"
              v-model="$v.form.name.$model">
            <template v-if="$v.form.name.$error">
              <div class="invalid-feedback" v-if="!$v.form.name.required">Este campo es obligatorio</div>
            </template>
          </div>
          <div class="col-12 col-lg-6 form-group">
            <label for="lastName">Apellidos</label>
            <input type="text"
              name="lastName"
              id="lastName"
              class="form-control"
              placeholder="Ingresa tus apellidos"
              v-model="$v.form.lastName.$model">
            <template v-if="$v.form.lastName.$error">
              <div class="invalid-feedback" v-if="!$v.form.lastName.required">Este campo es obligatorio</div>
            </template>
          </div>
          <div class="col-12">
            <hr>
          </div>
          <div class="col-12 col-lg-6 form-group">
            <label for="email">Correo Electrónico</label>
            <input type="email"
              name="email"
              id="email"
              class="form-control"
              placeholder="Ingresa tu correo electrónico"
              v-model="$v.form.email.$model">
            <template v-if="$v.form.email.$error">
              <div class="invalid-feedback" v-if="!$v.form.email.required">Este campo es obligatorio</div>
              <div class="invalid-feedback" v-if="!$v.form.email.email">Proporciona un correo electrónico válido</div>
            </template>
          </div>
          <div class="col-12 text-right">
            <input type="submit" value="Guardar usuario" class="btn btn-success px-4">
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import { validationMixin, } from "vuelidate";
  import { required, email, } from "vuelidate/lib/validators";
  export default {
    mixins: [
      validationMixin,
    ],
    data() {
      return {
        form: {
          name: "",
          lastName: "",
          email: "",
        },
      };
    },
    computed: {
      userId() {
        return this.$route.params.id;
      },
    },
    validations: {
      form: {
        name: { required, },
        lastName: { required, },
        email: { required, email, },
      }
    },
    methods: {
      async updateUser() {
        this.$v.form.$touch();

        if (this.$v.form.$anyError)
          return;
        
        try {
          await axios.put(`${process.env.VUE_APP_API_URL}/users/${this.userId}`, this.form);
          setTimeout(() => this.$router.replace({ name: "Users", }), 500);
          this.$swal("Operación exitosa", "Usuario actualizado con éxito", "success");
        } catch(e) {
          console.error(e);
          this.$swal("Error", e.response.data, "error");
        }
      },
    },
    created() {
      if (this.$store.state.editUser)
        this.form = this.$store.state.editUser;
      else
        this.$router.replace("/usuarios");
    }
  };
</script>